import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../../styles/theme";

const Button = (props) => {
  const {
    children = "",
    click,
    color,
    disabled,
    grey,
    marginRight,
    round,
    small,
    textColor,
    width,
  } = props;

  return (
    <div
      style={{
        display: "inline-block",
        width: width || "auto",
        verticalAlign: "top",
        marginRight,
      }}
    >
      <ThemeProvider theme={theme}>
        <BtnStyles
          onClick={disabled ? null : click}
          grey={grey}
          small={small}
          color={color}
          disabled={disabled}
          round={round}
          textColor={textColor}
        >
          {children}
        </BtnStyles>
      </ThemeProvider>
    </div>
  );
};

const BtnStyles = styled.div`
  height: ${({ small }) => (small ? "30px" : "38px")};
  line-height: ${({ small }) => (small ? "30px" : "38px")};
  font-weight: 500;
  font-size: 12px;
  color: ${({ textColor }) => textColor || "#fff"};
  padding-left: 22px;
  padding-right: 22px;
  text-align: center;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  border-radius: ${({ round }) => (round ? "100px" : "6px")};
  user-select: none;
  opacity: ${({ disabled }) => (disabled ? 0.3 : 1)};
  background: ${({ theme: { boldAccentColor, greyColor }, grey, color }) =>
    color || (grey ? "#ecedf4" : boldAccentColor)};
  transition: 0.3s ease all;

  :hover {
    opacity: 0.8;
  }
`;

export default Button;
